/**
 * Детект белого списка в Adblock Plus
 */

import { set as setCookie } from "OK/modules/storage/cookies";

import {getBannerStatLogger} from './BannerStat';

const TIMEOUT = 4000;
const COOKIE_NAME = 'abw';
const LOGGER_KEY = 'abp-wl';

function load(ch: number) {
    return new Promise<void>((resolve, reject) => {
        // @see https://jira.odkl.ru/browse/ADMONEY-54
        const script = document.createElement('script');
        script.src = 'https://limg.imgsmail.ru/informers/abp/px.js?ch=' + ch;
        script.onload = () => {
            resolve();
            getBannerStatLogger().success(LOGGER_KEY, `ch-${ch}.load`);
        };
        script.onerror = () => {
            reject();
            getBannerStatLogger().success(LOGGER_KEY, `ch-${ch}.error`);
        };
        document.head.appendChild(script);
    });
}

type TAbp = keyof typeof window;
(window as unknown as Record<string, unknown>)['abp'] = window['abp' as TAbp] || false;

const result = new Promise<void>((resolve, reject) => {
    // Даём 4 секунды на то, чтобы всё это добро отработало. Не успело - считаем, что мы не в белом списке
    setTimeout(reject, TIMEOUT);

    let error = false;

    // делаем тестовый запрос
    load(1)
        .catch(e => {
            // ошибка, значит что-то пошло не так - считаем, что ABP не распознан
            error = true;
            throw e;
        })
        .then(() => {
            // предыдущий запрос прошёл корректно - тестируем с новым параметром
            return load(2);
        })
        .then(
            reject, // если запрос был успешен - точно не белый список
            () => {
                // ошибка... возможно, мы в белом списке
                if (error || !window['abp' as TAbp]) {
                    // если попали сюда - считаем, что белый список адблока не распознан
                    reject();
                } else {
                    // ура! мы в белом списке
                    resolve();
                }
            }
        );
});

result.then(
    () => {
        setCookie(COOKIE_NAME, '1', 30, '/');
        getBannerStatLogger().success(LOGGER_KEY, 'yes');
    },
    () => {
        setCookie(COOKIE_NAME, '', 0, '/');
        getBannerStatLogger().success(LOGGER_KEY, 'no');
    }
);

export function detect() {
    return result;
}
